class GwpTierBar extends HTMLElement {
  constructor() {
    super();
    this.offers = [];
    this.freeShippingThreshold = parseFloat(this.getAttribute("data-free-shipping-threshold")) || 0;
    this.progressBarSelector = ".raftel_progress-bar__progress";
    this.offerNameListSelector = ".raftel_progress-bar__label__list";
    this.subHeadingSelector = ".raftel_progress-bar__subheading";
    this.tooltipSelector = ".raftel_progress-bar__tooltip";
    this.cartTotal = parseFloat(this.getAttribute("data-cart-total")) || 0;
  }

  async connectedCallback() {
    this.offers = window.raftelGwpOffers || [];
    if (this.offers.length > 0) {
      this.render();
    }
    this.listenForCartUpdates();
  }

  listenForCartUpdates() {
    console.log("GWP:: Tier bar connected");
    document.addEventListener("gwp:offers:updated", (event) => {
      console.log("GWP:: Tier bar updated");
      this.cartTotal = event.detail.total;
      this.offers = event.detail.offers;
      this.render();
    });
  }

  render() {
    this.querySelector(this.progressBarSelector).innerHTML = `
          <div class="raftel_progress-bar__progress-candycane-bg"></div>
          ${this.renderDivider()}
          ${this.renderProgressBarDots()}`;
    this.querySelector(this.offerNameListSelector).innerHTML = this.renderOfferNameLine();
    this.querySelector(this.subHeadingSelector).innerHTML = this.renderSubHeading();
    this.querySelector(this.tooltipSelector).innerHTML = this.renderTooltip();
    this.offsetProgressBar();
  }

  renderDivider() {
    if (this.offers.length === 1) {
      return "";
    }
    
    const dividers = [];
    const numberOfDividers = this.offers.length - 1;
    const segmentSize = 100 / this.offers.length;
    
    for (let i = 1; i <= numberOfDividers; i++) {
      const position = i * segmentSize;
      dividers.push(`<span class="raftel_progress-bar__divider" style="--left: ${position}%;"></span>`);
    }
    
    return dividers.join("");
  }

  renderSubHeading() {
    const nextOffer = this.offers.find((offer) => offer.pendingAmount > 0);
    return nextOffer
      ? `Add ${this.formatMoney(nextOffer.pendingAmount, true)} more to get a ${nextOffer.title}`
      : "You've unlocked all gifts!";
  }

  renderTooltip() {
    return this.formatMoney(this.cartTotal / 100, true);
  }

  renderProgressBarDots() {
    let dots = this.offers;
    if (this.freeShippingThreshold > 0) {
      dots = [{ threshold: this.freeShippingThreshold, enabled: true }, ...this.offers];
    }
    return dots
      .map((offer, index) => {
        return `
        <div class="raftel_progress-bar__dot raftel_progress-bar__dot--amount" style="left: ${this.getDotPosition(
          index, dots.length
        )}">
          <span>${this.formatMoney(offer.threshold, true)}</span>
        </div>
      `;
      })
      .join("");
  }

  renderOfferNameLine() {
    return this.offers
      .map((offer, index) => {
        return `
        <li class="raftel_progress-bar__label__item ${offer.pendingAmount <= 0 ? "active" : ""}">
          <span>${offer.title}</span>
        </li>
      `;
      })
      .join("");
  }

  getDotPosition(index, total) {
    // const positions = [12, 37, 62, 87];
    const positions = {
      1: [ 50 ],
      2: [ 24, 74 ],
      3: [ 16, 48, 82 ],
      4: [ 12, 37, 62, 87 ],
      5: [ 10, 30, 50, 70, 90 ],
      6: [ 8, 25, 42, 58, 75, 92 ]
    };
    return positions[total][index] + "%";
  }

  offsetProgressBar() {
    const cartTotal = this.cartTotal / 100;
    const maxOfferThreshold = Math.max(...this.offers.map((offer) => offer.threshold));
    const numberOfOffers = this.offers.length;

    // Sort offers by threshold to ensure proper ordering
    const sortedOffers = [...this.offers].sort((a, b) => a.threshold - b.threshold);

    let offset = 0;

    if (cartTotal >= maxOfferThreshold) {
      // Cart total exceeds all offers, set to 100%
      offset = 100;
    } else if (cartTotal === 0) {
      // No items in cart, set to 0%
      offset = 0;
    } else {
      // Calculate offset based on position relative to offer thresholds
      const segmentSize = 100 / numberOfOffers;

      // Find which segment the cart total falls into
      for (let i = 0; i < sortedOffers.length; i++) {
        const currentThreshold = sortedOffers[i].threshold;
        const previousThreshold = i === 0 ? 0 : sortedOffers[i - 1].threshold;

        if (cartTotal <= currentThreshold) {
          // Cart total is within this segment
          const progressInSegment = (cartTotal - previousThreshold) / (currentThreshold - previousThreshold);
          offset = (i * segmentSize) + (progressInSegment * segmentSize);
          break;
        }
      }
    }

    // Ensure offset doesn't exceed 100%
    offset = Math.min(offset, 100);

    this.querySelector(this.progressBarSelector).style.setProperty("--percentage", `${offset}%`);
    this.querySelector(this.tooltipSelector).style.setProperty("--left", `${offset}%`);
  }

  formatMoney(number, withoutZeroCents = false) {
    const currency = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) || "USD";
    if (withoutZeroCents) {
      return number.toLocaleString("en-US", {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    }
    return number.toLocaleString("en-US", { style: "currency", currency: currency });
  }

  disconnectedCallback() {
    console.log("GWP:: Tier bar disconnected");
  }
}

customElements.define("gwp-tier-bar", GwpTierBar);